import { TemplatesView } from '@/features/templates/TemplatesView'

export function TemplatesPage() {
  return <TemplatesView />
}
